// useMediaQuery — one boolean per CSS media query, kept current.
//
// For the cases where CSS alone cannot do it: rendering a DIFFERENT component
// tree per breakpoint (a compact row on a desktop, a card on a phone), not the
// same tree restyled. Hiding both with `hidden md:block` would double the DOM
// — on a 1 000-card register that is 1 000 extra photo elements.
//
// useSyncExternalStore, so the value is read synchronously on first render
// (no card-then-row flash) and subscribed without an effect. SSR / jsdom
// without matchMedia read `false`.
import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {}
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  )
}
